import { Injectable } from '@angular/core';
import { GetUserProfileGQL } from './../generated/gatewaygql';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class ProfileService {
    public user: any = {};

    constructor(
        private getUserProfileGQL: GetUserProfileGQL,
        private _authService: AuthenticationService,
    ) {
        // this.getUserProfile();
    }

    getUserProfile() {
        this.getUserProfileGQL.fetch({
            UserId: this._authService.userContext.lUserId
        }).subscribe(x => {
            this.user = x.data.User[0];
        });
    }
}
